import { useState, useCallback } from 'react';
const setNativeValue = (element, value) => {
  var _Object$getOwnPropert, _Object$getOwnPropert2;
  const valueSetter = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(element, 'value')) == null ? void 0 : _Object$getOwnPropert.set;
  const prototype = Object.getPrototypeOf(element);
  const prototypeValueSetter = (_Object$getOwnPropert2 = Object.getOwnPropertyDescriptor(prototype, 'value')) == null ? void 0 : _Object$getOwnPropert2.set;
  if (valueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter == null ? void 0 : prototypeValueSetter.call(element, value);
  } else {
    valueSetter == null ? void 0 : valueSetter.call(element, value);
  }
};
export const useValueState = (props, ref) => {
  const {
    emptyValue,
    defaultValue = emptyValue,
    value,
    onChange,
    onClean
  } = props;
  const [stateValue, setStateValue] = useState(defaultValue);
  return {
    value: value !== undefined ? value : stateValue,
    onChange: useCallback((event, params) => {
      setStateValue(params.value);
      onChange == null ? void 0 : onChange(event, params);
    }, [onChange]),
    onClean: (event, params) => {
      if ((ref == null ? void 0 : ref.current) instanceof Element) {
        setNativeValue(ref.current, defaultValue);
        ref.current.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
      setStateValue(defaultValue);
      onClean == null ? void 0 : onClean(event, params);
    }
  };
};